import React from 'react';
import ReactImageFallback from 'react-image-fallback';

import { makeSafe } from '../services/cloudinaryService';

function ImagePart({ url, alt, href, onClick }) {
  if (!url) return null;

  const imageAltText = alt || '';

  if (href !== undefined && href !== '') {
    return (
      <div className="c-card-banner">
        <a
          onClick={onClick}
          href={href}
          draggable="false"
        >
          <ReactImageFallback
            src={makeSafe(url)}
            fallbackImage="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xg8AAnMBeJQW2OIAAAAASUVORK5CYII="
            initialImage="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xg8AAnMBeJQW2OIAAAAASUVORK5CYII="
            alt={imageAltText}
          />
        </a>
      </div>
    );
  }
  return (
    <div className="c-card-banner">
      <ReactImageFallback
        src={makeSafe(url)}
        fallbackImage="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xg8AAnMBeJQW2OIAAAAASUVORK5CYII="
        initialImage="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xg8AAnMBeJQW2OIAAAAASUVORK5CYII="
        alt={imageAltText}
      />
    </div>
  );


}

export default ImagePart;



// WEBPACK FOOTER //
// ./src/parts/ImagePart.js